import { render, staticRenderFns } from "./communication.vue?vue&type=template&id=dde22ae4&scoped=true&"
import script from "./communication.vue?vue&type=script&lang=js&"
export * from "./communication.vue?vue&type=script&lang=js&"
import style0 from "./communication.vue?vue&type=style&index=0&id=dde22ae4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde22ae4",
  null
  
)

export default component.exports